<template>
  <div class="alert">

    <div class="tags">
      <div>
        <AlertTag v-for="tag in alert.tags" :key="tag" :title="tag" :manual="isTagManual(tag)" @click="clickTag(tag)" @delete="removeTag(tag)"/>
        <AlertTag :title="'add'" :create="true" @create="createTag"/>
      </div>
      <div>
        <div class="tag tag-btn" @click="removeLowRelevance" v-if="alert.tags.includes('lowrelevance')">Not low relevance</div>
        <div class="tag tag-btn" @click="setLowRelevance" v-else>Set low relevance</div>
        <div class="tag tag-btn" @click="removeFalsePositive" v-if="alert.tags.includes('falsepositive')">Not false positive</div>
        <div class="tag tag-btn" @click="setFalsePositive" v-else>Set false positive</div>
      </div>
    </div>

    <AlertUpdate class="alert-section" v-show="isAlertUpdateVisible" @close="closeAlertUpdate" :alert="alert"/>

    <div class="title">
      {{alert.type}}: {{alert.value}}<span class="password" v-show="alert.password">: {{alert.password}}</span>
    </div>

    <div class="keywords">
      <AlertKeyword v-for="keyword in alert.keywords" :key="keyword.id" :keyword="keyword"/>
    </div>

    <div class="timestamp">
      Indexed at: {{alert.timestamp}}
    </div>

    <div class="source">
      <div v-if="alert.source_title">
        Source: {{alert.source_title}}
      </div>
      <div v-if="alert.source_url">
        URL: <a target="_blank" :href="alert.source_url">{{alert.source_url}}</a>
      </div>
      <div v-if="alert.source_description">
        Description: {{alert.source_description}}
      </div>
    </div>

    <AlertContent :alert="alert"/>

    <AlertComments :alert="alert"/>

    <div class="footer">
      <div class="footer-item">
      </div>
      
      <div class="footer-item">
        <div>
          <button @click="toggleDebugMode" v-show="!alertDebugMode">Show raw alert</button>
          <button @click="toggleDebugMode" v-show="alertDebugMode">Hide raw alert</button>
        </div>
      </div>
      
    </div>

    <pre class="debug" v-show="debugMode|alertDebugMode">{{alert}}</pre>
    
  </div>

</template>

<style scoped>
.alert {
  margin-top: 5px;
  margin-bottom: 10px;
  padding: 5px;
  border-radius: 5px;
  border: 1px solid #cccccc;
}
.alert-menu {
  float: right;
}
.alert-section {
  margin-top: 3px;
}
.tags {
  display: flex;
  margin-top: -5px;
  margin-left: -3px;
  justify-content: space-between;
}
.title {
  font-size: 16px;
  font-weight: bold;
}
.password {
  font-size: 14px;
  color: red;
}
.timestamp {
  font-size: 12px;
  color: #aaaaaa;
}
.source {
  padding-top: 5px;
  font-size: 12px;
  word-break: break-all;
  word-wrap: break-word;
}
.footer {
  display: flex;
  justify-content: space-between;
  margin-top: 3px;
}
.footer-item {
   display: flex;
}
</style>

<script>

import tags from '@/assets/tags'

import { mapState } from 'vuex'
import AlertTag from './AlertTag.vue'
import AlertUpdate from './AlertUpdate.vue'
import AlertKeyword from './AlertKeyword.vue'
import AlertContent from './AlertContent.vue'
import AlertComments from './AlertComments.vue'

export default {
  name: 'Alert',
  components: {
    AlertTag,
    AlertUpdate,
    AlertKeyword,
    AlertContent,
    AlertComments
  },
  props: {
    alert: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState([
      'debugMode',
      'apiAccount'
    ])
  },
  methods: {
    toggleDebugMode () {
      this.alertDebugMode = !this.alertDebugMode
    },
    isTagManual (tag) {
      if (tags.severity.includes(tag) && this.alert.manual_severity) return true
      if (tags.category.includes(tag) && this.alert.manual_category) return true
      return false
    },
    isTagReserved (tag) {
      if (!tags.reserved.includes(tag)) return true
      return false
    },  
    addTag () {
      this.addingTag = true
    },
    saveTag () {
      if (this.newTag) {
        this.$store.dispatch('addAlertTag', {
          alert: this.alert,
          tag: this.newTag
        })
      }
      this.newTag = ''
      this.addingTag = false
    },
    cancelTag () {
      this.newTag = ''
      this.addingTag = false
    },
    createTag (tag) {
      // console.log('Creating tag ' + tag)
      if (tag) {
        this.$store.dispatch('addAlertTag', {
          alert: this.alert,
          tag: tag
        })
      }
    },
    removeTag (tag) {
      if (!confirm('Are you sure? This will delete tag <' + tag + '> permanently!')) return
      this.$store.dispatch('removeAlertTag', {
        alert: this.alert,
        tag: tag
      })
    },
    setLowRelevance () {
      // console.log('setFalsePositive')
      this.$store.dispatch('updateAlert', {
          alert: this.alert,
          severity: 'lowrelevance'
        })
    },
    removeLowRelevance () {
      // console.log('removeLowRelevance')
      this.$store.dispatch('updateAlert', {
          alert: this.alert,
          severity: 'default'
        })
    },
    setFalsePositive () {
      // console.log('setFalsePositive')
      this.$store.dispatch('updateAlert', {
          alert: this.alert,
          severity: 'falsepositive'
        })
    },
    removeFalsePositive () {
      // console.log('removeFalsePositive')
      this.$store.dispatch('updateAlert', {
          alert: this.alert,
          severity: 'default'
        })
    },
    clickTag (tag) {
      if (tags.severity.includes(tag) || tags.category.includes(tag)) {
        this.isAlertUpdateVisible = !this.isAlertUpdateVisible
      }
    },
    closeAlertUpdate () {
      this.isAlertUpdateVisible = false
    }
  },
  data () {
    return {
      alertDebugMode: this.debugMode,
      isAlertUpdateVisible: false,
      addingTag: false,
      newTag: ''
    }
  },
}
</script>
